import { Dayjs } from 'dayjs';
import { JobDashboardRange } from '../job-dashboard/job-dashboard-configuration';
import { ResultFieldFilter } from '../job-result-analytics-dashboard/job-result-analytics-dashboard-configuration';

export enum UnitSourceType {
  ELEMENT_COUNT = 'ELEMENT_COUNT',
  FIELD_SUM = 'FIELD_SUM',
}

export interface AveragePickTimeDashboardConfiguration {
  title?: string;
  description?: string;
  dataConnectionIds?: string[];
  /** Job statuses to include; the backend defaults to COMPLETE when empty. */
  statuses?: string[];
  range: JobDashboardRange;
  from?: Dayjs;
  to?: Dayjs;
  /** How picked units are counted: one per result element, or the sum of a numeric field. */
  unitSourceType: UnitSourceType;
  /** Numeric JSON field on job result entries summed as units (e.g. "quantity"). FIELD_SUM only. */
  unitFieldKey?: string;
  filters?: ResultFieldFilter[];
}

/** Maximum filters per request. Must match backend MAX_FILTERS. */
export const MAX_FILTERS = 10;

/** Maximum date range in days. Must match backend MAX_DATE_RANGE_DAYS (91 to account for timezone edge cases). */
export const MAX_DATE_RANGE_DAYS = 91;
